import { render, staticRenderFns } from "./UkTermsOfUse.vue?vue&type=template&id=0313925a&scoped=true"
import script from "./UkTermsOfUse.vue?vue&type=script&lang=js"
export * from "./UkTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0313925a",
  null
  ,true
)

export default component.exports